<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{'general.loading' | translate}}...</p>
</ngx-spinner>
<div class="col-12" id="account">
    <h2 class="page-title" tabindex="0">{{'account.account' | translate}}</h2>

    <xng-breadcrumb separator=" > ">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
            <span *ngIf="breadcrumb">{{ 'account.' + breadcrumb | translate }}</span>
        </ng-container>
    </xng-breadcrumb>
    <div id="account-owner">
        <div class="row">
            <div class="col-5">
                <div class="card border-top">
                    <div class="card-body">
                        <h4>{{'account.account_information' | translate}}</h4>
                        <hr>
                        <div class="row">
                            <div class="col-12 profile-pic text-center">
                                <img class="img-round" [src]="organization?.logo?organization.logo:'assets/images/company.png'" width="120" height="120" alt="{{organization?.name}}" />
                                <div class="edit" *ngxPermissionsExcept="['Activate', 'Expired']"><button class="btn btn-blue btn-h-blue" routerLink="edit-picture" routerLinkActive="active"><i class="fa fa-pencil fa-md pr-1"></i> {{'general.edit' | translate}}</button></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center">
                                <strong>{{organization?.name}}</strong>
                            </div>
                        </div>
                        <div class="row pt-10">
                            <div class="col-6">
                                <i class="fa fa-user"></i>&nbsp;<strong>{{'account.owner' | translate}}:</strong>
                            </div>
                            <div class="col-6">
                                {{organization?.profileFirstName}} {{organization?.profileLastName}}
                            </div>
                        </div>
                        <div class="row pt-10">
                            <div class="col-6">
                                <i class="fa fa-envelope"></i>&nbsp;<strong>{{'general.email' | translate}}:</strong>
                            </div>
                            <div class="col-6">
                                {{email}}
                            </div>
                        </div>
                        <div class="row pt-10">
                            <div class="col-6">
                                <i class="fa fa-phone"></i>&nbsp;<strong>{{'account.owner_phone' | translate}}:</strong>
                            </div>
                            <div class="col-6">
                                {{organization?.profilePhoneNumber}}
                            </div>
                        </div>
                        <div class="row pt-10">
                            <div class="col-6">
                                <i class="fa fa-phone"></i>&nbsp;<strong>{{'account.org_number1' | translate}}<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{'account.org_number2' | translate}}:</strong>
                            </div>
                            <div class="col-6">
                                {{organization?.phoneNumber}}
                            </div>
                        </div>
                        <div class="row pt-10">
                            <div class="col-6">
                                <i class="fa fa-map-marker"></i>&nbsp;<strong>{{'user.address' | translate}}:</strong>
                            </div>
                            <div class="col-6">
                                {{organization.fullAddress}}
                            </div>
                        </div>
                        <br>
                        <div class="row m-0" *ngxPermissionsExcept="['Activate', 'Expired']">
                            <button routerLink="edit-account" routerLinkActive="active" class="btn btn-blue btn-h-blue w-100" title="{{'account.edit-account' | translate}}"><strong>{{'account.edit-account' | translate}}</strong></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-7">
                <div class="card border-top">
                    <div class="card-body">
                        <h4>{{((!subscription?.periodCanceled && !nextPeriod?.canceled)?'account.active_subscription':'account.canceled_subscription') | translate}}</h4>
                        <hr> 
                        <div class="canceledBox row p-2 m-0 mb-3" *ngIf="subscription?.periodCanceled || nextPeriod?.canceled || subscription?.expired">
                            <div *ngIf="remaining_days>=0 && !subscription?.expired" class="col-12">
                                {{'account.subscription_canceled1' | translate}} {{nextPeriod!=null?functionsService.convertUTCDateToLocalDateOnly(nextPeriod.endDate):functionsService.convertUTCDateToLocalDateOnly(endDate)}}. {{'account.subscription_canceled2' | translate}} <a (click)="reactivateSubscription()" class="custom-hyperlink">{{'general.click_here' | translate}}</a>.
                            </div>
                            <div *ngIf="remaining_days<=0 && subscription?.expired" class="col-12">
                                {{'account.expired_subscription' | translate}} <a routerLink="subscription-purchase" routerLinkActive="active" class="custom-hyperlink">{{'general.click_here' | translate}}</a>.
                            </div>                          
                        </div>
                        <!-- <div class="keepPlanBox row p-2 m-0 mb-3" *ngIf="(!nextPeriod?.paid) && (subscription?.price > nextPeriod?.price) && keep_plan">
                            <div class="col-12" id="keepMessage">
                            {{keep_plan}} <a (click)="keepCurrentPlan()" class="custom-hyperlink"><b>{{'general.click_here' | translate}}</b></a>.
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="logo">
                                <img src="assets/images/sa-icon.png" alt="{{'alt.sa_logo' | translate}}" class="rounded ml-2" width="30" height="30">
                            </div>
                            <div class="col-11">
                                <h4>Contigo MSJ - {{((subscription?.planName != null)?subscription?.planName:'') | translate}}{{(subscription?.periodTrial)?" ":""}}{{(subscription?.periodTrial?'account.trial_7':"") | translate}}&nbsp;&nbsp;
                                    <a *ngIf="((!subscription?.periodCanceled && !nextPeriod?.canceled)&&(!subscription?.periodTrial))" tabindex="0" class="custom-hyperlink" (click)="changePlan()" (keydown.enter)="changePlan()"><u aria-label="change plan link">{{'account.change_plan' | translate}}</u></a>
                                </h4>
                                <div *ngIf="subscription?.periodTrial" class="row mt-3">
                                    <div class="col-12">
                                        <span>{{trial_message}} <span *ngIf="remaining_days>0 && !subscription?.canceled && !subscription?.periodCanceled && !nextPeriod?.canceled">{{'account.trial_days_leftb' | translate}}<span class="custom-hyperlink" (click)="cancelSubscription()">{{'account.here' | translate}}</span> {{'account.trial_days_rightb' | translate}}</span></span>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-4">
                                        <strong>{{'account.subscription_id' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{subscription?.key}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">
                                        <strong>{{'roles.agents_supervisors' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{subscription?.agentsSupervisors}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">
                                        <strong>{{'roles.users' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{subscription?.users}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">
                                        <strong>{{'plan.video_feature' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{subscription?.includesVideo ? ('setting.yes' | translate): ('setting.no' | translate)}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">
                                        <strong>{{'plan.agent_dispatch' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{subscription?.agentDispatch ? ('setting.yes' | translate): ('setting.no' | translate)}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">
                                        <strong>{{'plan.geo_zone_assignment' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{subscription?.geoAssignment ? ('setting.yes' | translate): ('setting.no' | translate)}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">
                                        <strong>{{'subscription.created_date' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{subscription?(functionsService.convertUTCDateToLocalDateOnly(subscription?.created)):''}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-4">
                                        <strong>{{'account.billing_cycle' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{(subscription?('account.'+subscription?.cycle):'') | translate}}
                                    </div>
                                </div>
                                <br>
                                <div class="row m-0">
                                    <button routerLink="subscription-details" routerLinkActive="active" class="btn btn-blue btn-h-blue w-100" title="{{'account.view_subscription' | translate}}"><strong>{{'account.view_subscription' | translate}}</strong></button>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-12">
                                        <strong>{{'account.preferred_payment_info' | translate}}:</strong>
                                    </div>
                                    <div class="col-12 mt-3 d-flex justify-content-center">
                                        <div class="card w-75">
                                            <div class="card-body">
                                                <div *ngIf="cardInfo!=null && cardInfo.cardType">
                                                    <div class="row">
                                                        <div class="col-12 text-right h2"><i [class]="cardInfo['card-fa']"></i></div>
                                                        <div class="col-12">**** **** **** {{cardInfo.cardLast4Digits}}</div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-8 text-left">{{cardInfo.cardName}}</div>
                                                        <div class="col-4 text-right">{{cardInfo.cardExpirationMonth}}/{{cardInfo.cardExpirationYear}}</div>
                                                    </div>
                                                </div>
                                                <div class="text-center" *ngIf="cardInfo==null || !cardInfo.cardType">
                                                    N/A
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-0">
                                    <button routerLink="payment-methods" routerLinkActive="active" class="btn btn-blue btn-h-blue w-100 mt-3" title="{{'account.manage_methods' | translate}}"><strong>{{'account.manage_methods' | translate}}</strong></button>
                                </div>
                                <div class="font-small pt-2 dark-gray-text">
                                    {{'account.support_contact' | translate}}: <a class="custom-hyperlink" href="mailto:support@socialalert.app">support@socialalert.app</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
